module.exports = __webpack_public_path__ + "static/avaliable-logo-bar-mobile-7144851e12dbe0afd842bf6de6aeb925.png";